import _ from "lodash";
import {
    RECEIVE_INVOICES,
    RECEIVE_INVOICES_FILTER,
    FETCH_INVOICES_REQUEST,
    FETCH_INVOICES_FILTER_REQUEST,
    EXPORT_INVOICE_REQUEST,
    EXPORT_INVOICE_DONE,
    MESSAGE_INVOICE,
    CLEAR_INVOICE_PAGINATION,
    SET_ITEMS_OFFSET,
    SET_FILTERS
} from '../constants';
import { createReducer } from '../utils/misc';
import Settings from "../settings";

const initialState = {
    data: {},
    isFetching: false,
    loaded: false,
    download_status: {},
    invoice_function: null,
    itemsPage: Settings?.invoices?.itemsPerPage ?? 100,
    itemsTotal: 0,
    itemsOffset: 0,
    filters: {
        loading: false,
        data: {},
        currentFilter: ''
        // cache: {}
    },
    errors: null
};

export default createReducer(initialState, {
    [RECEIVE_INVOICES]: (state, payload) => {
        // const newItems = _.union(state.filters.cache[payload.filters].items, payload.response.items);
        return Object.assign({}, state, {
            items: payload.response.items,
            itemsTotal: payload.response.n_items,
            itemsOffset: payload.response.offset,
            itemsPage: payload.response.limit,
            isFetching: false,
            loaded: true,
            message_text: payload.message,
            errors: payload.errors,
            // filters: {
            //     ...state.filters,
            //     currentFilter: payload.filters
                // cache: {
                //     ...state.filters.cache,
                //     [payload.filters]: {
                //         items: newItems
                //     },
                //     n_items: payload.n_items,
                //     recieved: newItems.length
                // }
            // }
        })
    },
    [SET_ITEMS_OFFSET]: (state, payload) =>
        Object.assign({}, state, {
            itemsOffset: payload.itemsOffset
        }),
    [SET_FILTERS]: (state, payload) =>
        Object.assign({}, state, {
            itemsPage: payload.itemsPage,
            itemsOffset: payload.itemsOffset,
            filters: {
                ...state.filters,
                currentFilter: payload.currentFilter
            }
        }),
    [CLEAR_INVOICE_PAGINATION]: (state, payload) =>
        Object.assign({}, state, {
            itemsPage: Settings?.invoices?.itemsPerPage ?? 100,
            itemsTotal: 0,
            itemsOffset: 0,
        }),
    [RECEIVE_INVOICES_FILTER]: (state, payload) =>
        Object.assign({}, state, {
            filters: {
                ...state.filters,
                loading: false,
                data: payload
            }
        }),
    [FETCH_INVOICES_REQUEST]: (state, payload) =>
        Object.assign({}, state, {
            isFetching: true,
            loaded: false,
            message_text: payload.message,
        }),
    [FETCH_INVOICES_FILTER_REQUEST]: (state, payload) =>
        Object.assign({}, state, {
            filters: {
                ...state.filters,
                loading: true,
                data: {}
            }
        }),
    [EXPORT_INVOICE_REQUEST]: (state, payload) => {
        const download_status = Object.assign({}, state.download_status);
        download_status[payload.invoice] = true;
        return Object.assign({}, state, {
            download_status,
            message_text: payload.message
        });
    },
    [EXPORT_INVOICE_DONE]: (state, payload) => {
        const download_status = Object.assign({}, state.download_status);
        download_status[payload.invoice] = false;
        return Object.assign({}, state, {
            download_status
        });
    },
    [MESSAGE_INVOICE]: (state, payload) => {
      return Object.assign({}, state, {
            message_text: payload.message,
        })
    },
});
